import { components } from './components';
import { palette } from './palette';
import { shadows } from './shadows';
import { shape } from './shape';
import { typography } from './typography';
export var theme = {
    components: components,
    palette: palette,
    shape: shape,
    shadows: shadows,
    typography: typography,
    // This will preserve 8px spacing, but will scale with base font size because of rem.
    /**
     * Return spacing in rems (0.5 * factor)
     * @param factor number
     * @returns string with rem value
     */
    spacing: function (factor) { return "".concat(0.5 * factor, "rem"); },
};
